import {
  AppointmentRepoImpl,
  AuthRepoImpl,
  BlogPostRepoImpl,
  ChatRepoImpl,
  CouponRepoImpl,
  NotificationRepoImpl,
  PamiaChatRepoImpl,
  PartnershipRepoImpl,
  PaymentRepoImpl,
  RatingRepoImpl,
  ScheduleRepoImpl,
  SettingsRepoImpl,
  SharedAppointmentSlotRepoImpl,
  UserRepoImpl,
} from "@phurshell/psiapp-frontend-core/data";
import {
  appointmentDataSource,
  authDataSource,
  blogPostDataSource,
  chatDataSource,
  couponDataSource,
  notificationDataSource,
  pamiaChatDataSource,
  partnershipDataSource,
  paymentDataSource,
  ratingDataSource,
  scheduleDataSource,
  settingsDataSource,
  sharedAppointmentSlotDataSource,
  userDataSource,
} from "./datasources";
import {
  appointmentMapper,
  chatMapper,
  couponMapper,
  notificationMapper,
  partnershipMapper,
  paymentMapper,
  scheduleMapper,
  userMapper,
} from "./mappers";

export const authRepo = new AuthRepoImpl(authDataSource);
export const userRepo = new UserRepoImpl(userDataSource, userMapper);
export const appointmentRepo = new AppointmentRepoImpl(
  appointmentDataSource,
  appointmentMapper,
);
export const chatRepo = new ChatRepoImpl(chatDataSource, chatMapper);
export const paymentRepo = new PaymentRepoImpl(paymentDataSource, paymentMapper);
export const settingsRepo = new SettingsRepoImpl(settingsDataSource);
export const scheduleRepo = new ScheduleRepoImpl(scheduleDataSource, scheduleMapper);
export const notificationRepo = new NotificationRepoImpl(
  notificationDataSource,
  notificationMapper,
);
export const ratingRepo = new RatingRepoImpl(ratingDataSource);
export const couponRepo = new CouponRepoImpl(couponDataSource, couponMapper);
export const sharedAppointmentSlotRepo = new SharedAppointmentSlotRepoImpl(
  sharedAppointmentSlotDataSource,
);
// exclusivos do paciente (não existem no pro)
export const partnershipRepo = new PartnershipRepoImpl(
  partnershipDataSource,
  partnershipMapper,
);
export const blogPostRepo = new BlogPostRepoImpl(blogPostDataSource);
export const pamiaChatRepo = new PamiaChatRepoImpl(pamiaChatDataSource);

export const repos = {
  authRepo,
  userRepo,
  appointmentRepo,
  chatRepo,
  paymentRepo,
  settingsRepo,
  scheduleRepo,
  notificationRepo,
  ratingRepo,
  couponRepo,
  sharedAppointmentSlotRepo,
  partnershipRepo,
  blogPostRepo,
  pamiaChatRepo,
};
